module.exports = __webpack_public_path__ + "img/jiezhang.81a09624.png";